import { NavSubItem } from './nav-sub-item';

export class ProductsSubNavItem extends NavSubItem {}
